import React from 'react';
import { GiBroom } from "react-icons/gi";
import { MdDoneAll } from "react-icons/md";
import { Row, Col, Button, Card, CardBody } from 'reactstrap';

//Componentes auxiliares
import CustomCheckbox from './CustomCheckbox';

class ChecksFilterManager extends React.Component {

    constructor() {
        super();

        this.state = {} //El state se llena automáticamente según el array de filteringOptions
    }

    render() {
        return (
            <Card>
                <CardBody>
                    <Row style={{ marginBottom: 10 }}>
                        <Col xs="8" md="8" lg="8" xl="8">
                            <div style={{ display: "table", overflow: "hidden", height: 42 }}>
                                <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                                    <h6 className="card-title noselect" style={{ cursor: "pointer", marginBottom: 0 }}>
                                        <p style={{ fontSize: 10, marginBottom: 0 }}>{this.props.title || "@Titulo"}</p>
                                    </h6>
                                </div>
                            </div>
                        </Col>

                        <Col xs="4" md="4" lg="4" xl="4" style={{ textAlign: "right" }}>
                            {this.props.actionButtons}

                            <Button
                                className="btn btn-default"
                                onClick={this.fastActionButtonClick}
                                key="actionButtonForDownloadSourcesFilterManager"
                                data-tut="reactour__mainLayout.filterManagerQuickButton"
                                style={{ padding: "3px 10px", backgroundColor: "transparent", color: "#65615c", marginLeft: 5 }}>

                                {this.getFastActionButtonIcon()}
                            </Button>
                        </Col>
                    </Row>

                    {this.getOptionsCheckboxes()}

                    <Row style={{ flexDirection: "column", alignItems: "center", paddingTop: 15, paddingLeft: "5%", paddingRight: "5%" }}
                        data-tut="reactour__processesRegistry.processesRegistryTablePaginationResume">
                        <p className="card-category" style={{ marginBottom: 5, fontSize: 10, textTransform: "uppercase" }}>
                            <b>{this.getQuantityDescription(this.props)}</b>
                        </p>
                    </Row>
                </CardBody>
            </Card>
        );
    }

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.originalData) !== JSON.stringify(this.props.originalData)) { 
            if (!this.props.initialFilter) {
                if (JSON.stringify(this.props.originalFilters) !== JSON.stringify({})) {
                    this.setState(this.props.originalFilters);
                    this.props.filteredDataCallback(this.props.originalFilters);
                }
                else {
                    let allFiltersOnObject = {};
                    this.props.filteringOptions.forEach((optionItem, i) => {
                        allFiltersOnObject[optionItem[this.props.filteringKey]] = true;
                    });
                    this.setState(allFiltersOnObject);
                    this.props.filteredDataCallback(allFiltersOnObject);
                }
            }
            else {
                let allFiltersOnObject = {};
                allFiltersOnObject[this.props.initialFilter] = true;
                this.setState(allFiltersOnObject);
                this.props.filteredDataCallback(allFiltersOnObject);
            }
        }
    }

    //Métodos para renderizado:
    fastActionButtonClick = () => {
        let theBroomShouldBeDisplayed = this.shouldTheBroomBeDisplayed();

        if (theBroomShouldBeDisplayed) {
            let updateObject = { ...this.state };
            let updateObjectKeys = Object.keys(updateObject);

            updateObjectKeys.forEach((key) => { updateObject[key] = false });

            this.setState(updateObject);
            this.props.filteredDataCallback(updateObject);
        }
        else {
            let updateObject = {};
            this.props.filteringOptions.forEach((optionItem) => { updateObject[optionItem[this.props.filteringKey]] = true });

            this.setState(updateObject);
            this.props.filteredDataCallback(updateObject);
        }
    }

    getFastActionButtonIcon = () => {
        return ((this.shouldTheBroomBeDisplayed()) ? <GiBroom /> : <MdDoneAll />);
    }

    getOptionsCheckboxes = () => {
        return this.props.filteringOptions.map((optionItem, i) => {
            let checkedValue = this.state[optionItem[this.props.filteringKey]];
            if (checkedValue === undefined) { checkedValue = false; };

            return (
                <CustomCheckbox
                    checked={checkedValue}
                    key={this.props.managerKey + ".checkbox." + i}
                    itemRendering={this.props.itemRendering(optionItem)}
                    onChange={(newValue) => {
                        let newState = { ...this.state };
                        newState[optionItem[this.props.filteringKey]] = newValue;

                        this.props.filteredDataCallback(newState);
                        this.setState({ ...newState });
                    }} />
            );
        })
    }

    getQuantityDescription = (props) => {
        let activeQuantity = props.activeQuantity;
        if (props.activeQuantity >= props.totalRegisters) { activeQuantity = props.totalRegisters }
        if (props.totalRegisters < props.activeQuantity) { activeQuantity = props.totalRegisters }

        return ("Estoy viendo " + activeQuantity + " registros de " + props.totalRegisters);
    }

    //Métodos operativos:
    shouldTheBroomBeDisplayed = () => {
        let activeCheckboxes = 0;
        let stateKeys = Object.keys(this.state);

        for (let i = 0; i < stateKeys.length; i++) { if (this.state[stateKeys[i]]) { activeCheckboxes++; } }
        return (activeCheckboxes === this.props.filteringOptions.length);
    }

}

export default ChecksFilterManager;